import React from 'react'
import IndexComponent from './IndexComponent'
import useWpJson from '../../Hooks/useWpJson'
export default function SlideShow ({
  gallery,
  ...props
}) {
  const ids = gallery?.map(({ ID }) => ID).join(',')
  const catId = useWpJson(`posts?include=${ids}&acf_format=standard`)
  return <IndexComponent jsonResponse={catId} {...props} />
}
